export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7466.5e7438e1.jpg";